import React, { useState } from 'react';
import FileUploadComponent from './FileUploadComponent';
import ChatInterface from './ChatInterface';

function Layout() {
  const [namespace, setNamespace] = useState('default'); // Set a default namespace
  const [isIndexing, setIsIndexing] = useState(false);

  const handleNamespaceChange = (newNamespace) => {
    setNamespace(newNamespace);
  };

  const handleIndexingChange = (indexing) => {
    setIsIndexing(indexing);
  };

  return (
    <div className="flex h-screen bg-gray-100 p-6">
      <div className="w-2/3 pr-6">
        <div className="bg-white rounded-lg shadow-lg h-full">
          <ChatInterface namespace={namespace} isIndexing={isIndexing} />
        </div>
      </div>
      <div className="w-1/3">
        <FileUploadComponent 
          onNamespaceChange={handleNamespaceChange} 
          onIndexingChange={handleIndexingChange}
        />
      </div>
    </div>
  );
}

export default Layout;
